module.exports = __webpack_public_path__ + "static/media/odonto.2fe06cfa.svg";